import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import FinalizeTpClientInvoiceItem from '../../../Domain/FinalizeTpClientInvoiceItem';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import {
  checkFinalizeComment,
  checkJobsNoLongerReadyChoice,
  getFinalizeRequest,
  hasJobsNoLongerReady,
} from '../../../Helpers/finalizeJobsNoLongerReadyHelper';

// The admin page reads the invoice's shops that no longer pass the Ready for Invoicing rules before it opens the
// window (JobsNoLongerReady); when there are any, the window lists them, set to be removed. A user who may keep them
// can choose to, with a comment.
export default class FinalizeTpClientInvoiceWindowDescription extends React.Component {
  static titleForEdit = (editedItem) => `Finalize Client Invoice (#${editedItem.TpClientInvoiceId})`;
  static finishButtonLabel = 'Finalize';
  static itemType = FinalizeTpClientInvoiceItem;
  static serviceFunction = (editedItem) => TpClientInvoiceService.FinalizeInvoice(getFinalizeRequest(editedItem));

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          // CD-5483: set by TpClientInvoiceAdmin.openFinalizeWindow; empty when no evaluator payment of the
          // invoice would need supervisor approval.
          fieldName: 'EvaluatorPaymentApprovalNote',
          label: 'Supervisor approval',
          className: 'col-12',
          type: InputTypesEnum.TextBoxReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !item.EvaluatorPaymentApprovalNote,
        },
        {
          fieldName: 'FulfillmentDate',
          label: 'Fullfillment Date',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: FinalizeTpClientInvoiceWindowDescription.validateFulfillmentDate,
          hide: (item) => item.OfficeId !== 9,
        },
        {
          fieldName: 'JobsNoLongerReadyChoice',
          label: 'Shops No Longer Ready For Invoicing *',
          className: 'col-12',
          type: InputTypesEnum.JobsNoLongerReadyChoiceSelect,
          validityChecker: checkJobsNoLongerReadyChoice,
          hide: (item) => !hasJobsNoLongerReady(item),
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: checkFinalizeComment,
        },
      ],
    },
  ];

  static validateFulfillmentDate(e, editedItem) {
    if (editedItem.OfficeId === 9) {
      const fulfillmentDate = new Date(e);
      const lowerLimit = new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(), 1)));
      const upperLimit = FinalizeTpClientInvoiceWindowDescription.calculateUpperLimit();
      if (fulfillmentDate < lowerLimit || fulfillmentDate >= upperLimit || e === 'NaN-NaN-NaN') {
        return "The date can't be before tomorrow or later than end of month + 60 days.";
      }
    }

    return '';
  }

  static calculateUpperLimit() {
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const endOfMonth = new Date(year, month, dateTimeHelper.LastDayOfMonth(year, month));
    return dateTimeHelper.addDaysToDate(endOfMonth, 61);
  }
}
